/**
 * Unsafe string interpolation function. Not for use with user input.
 * @param target template string with ${} placeholders for values
 * @param data object with keys that match the placeholders in the template string
 */
export const replacer = (target: string, data: Record<string, string | number>) => {
  return target.replace(/\$\{(\w+)\}/g, (_, key) => {
    const value = data[key];
    if (value === undefined) {
      throw new Error(`Missing value for key ${key}`);
    }
    return value.toString();
  });
};

// normalizes a string by removing spaces and converting to lowercase
export const normalize = (str: string) => str?.replace(/\s/g, '').toLowerCase();
